import React from 'react';
import { useTranslation } from 'react-i18next';
import DataTable, { TableColumn } from 'react-data-table-component';

import customStyles from './CustomTableStyles';
import CustomExpander from './CustomExpander/CustomExpander';

interface FilterDataTableProps<T> {
  columns: TableColumn<T>[];
  data: T[];
  isLoading: boolean;
  expandableRows?: boolean;
  expandableRowsComponent?: React.FC<{ data: T }>;
  expandableRowsComponentProps?: {
    slug: string;
  };
}

function ObjectListDataTable<T>({
  columns,
  data,
  isLoading,
  expandableRows = false,
  expandableRowsComponent,
  expandableRowsComponentProps,
}: FilterDataTableProps<T>) {
  const { t } = useTranslation();
  // Conditional row styles for activity status traps
  const conditionalRowStyles = [
    {
      when: (row: any) => row.is_activity === true,
      style: {
        backgroundColor: 'rgba(240, 101, 72, 0.2)',
      },
    },
  ];
  return (
    <div className="p-3">
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2" />
      <DataTable
        columns={columns}
        data={data}
        progressPending={isLoading}
        conditionalRowStyles={conditionalRowStyles}
        pagination={false}
        customStyles={customStyles}
        dense
        sortServer
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        expandableRowsComponentProps={expandableRowsComponentProps}
        expandableIcon={{
          collapsed: <CustomExpander isExpanded={false} />,
          expanded: <CustomExpander isExpanded />,
        }}
        onRowMouseEnter={(row: T, event: React.MouseEvent<Element, MouseEvent>) => {
          if ((row as any).is_activity) {
            (event.currentTarget as HTMLElement).setAttribute(
              'title',
              t('ClientsAccordion.accordion.accordion-item.title-active'),
            );
          } else {
            (event.currentTarget as HTMLElement).removeAttribute('title');
          }
        }}
      />
    </div>
  );
}

export default ObjectListDataTable;
